<template>
  <section class="section newsletter-section">
    <HgNewsletterBox
      v-if="loggedInUser"
      :loading="loading"
      :success="success"
      :user-e-mail="loggedInUser.email"
      @onSubscribe="subscribe"
    />
    <HgNewsletterBox
      v-else
      :loading="loading"
      :success="success"
      @onSubscribe="subscribe"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import createNewsletterUserMutation from '@/apollo/mutations/newsletter/createNewsletterUser';
import getNewsletterUserQuery from '@/apollo/queries/newsletter/getNewsletterUser';

export default {
  data: () => ({
    error: null,
    success: false,
    loading: false,
    newsletterUser: null,
  }),
  computed: {
    ...mapGetters({
      loggedInUser: 'auth/loggedInUser',
    }),
  },
  async mounted() {
    if (!this.loggedInUser) return;

    try {
      const {
        data: { getNewsletterUser },
      } = await this.$apollo.query({
        query: getNewsletterUserQuery,
        variables: {
          mail: this.loggedInUser.email,
        },
      });

      this.newsletterUser = getNewsletterUser;
    } catch (e) {
      console.warn('Error', e.graphQLErrors);
      this.errors = e.graphQLErrors;
    }
  },
  methods: {
    async subscribe(email) {
      this.loading = true;
      const firstName = this.loggedInUser
        ? this.loggedInUser.profile.firstName
        : 'Technical';
      const lastName = this.loggedInUser
        ? this.loggedInUser.profile.lastName
        : 'User';

      try {
        const {
          data: { createNewsletterUser },
        } = await this.$apollo.mutate({
          mutation: createNewsletterUserMutation,
          variables: {
            firstName,
            lastName,
            email,
          },
        });

        if (createNewsletterUser) {
          this.success = true;
        }
      } catch (e) {
        console.warn('Error', e.graphQLErrors);
        this.errors = e.graphQLErrors;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.newsletter-section {
  max-width: 1400px;
  margin: 0 auto;
}

.newsletter-section:deep(.hg-newsletter-box__content--success) {
  margin: 0 auto;
}
</style>
